/** @format */

export const EXTERNAL_ITEMS = [
  {
    label: 'menu_external_home',
    href: 'menu_external_home_link',
    home: true,
    external: true,
    active: false,
  },
  {
    label: 'menu_living_coliving_label',
    href: 'menu_coliving_link',
    external: false,
    active: true,
  },
  {
    label: 'menu_travel',
    href: 'menu_travel_link',
    external: true,
    active: false,
  },
  {
    label: 'menu_student',
    href: 'menu_student_link',
    external: true,
    active: false,
  },
];
